export const packageStudent = [
  {
    path: "/package-student/packages",
    component: () => import("@/modules/package_student/PackageManagementPage.vue"),
  },
  {
    path: "/package-student/school-packages",
    component: () => import("@/modules/package_student/SchoolPackageAssignPage.vue"),
  },
];
